import { createSlice } from '@reduxjs/toolkit';
import { recreateAdDemo } from './demoRecreateActions';

const initialState = {
  password: '',
  attempts: 0,

  imagesContent: [],
  isImagesLoading: false,
  imagesTableSettings: {
    page: 1,
    size: 8,
    totalElements: 0,
  },

  isGenerating: false,
  attemptsError: false,
};

const demoRecreateSlice = createSlice({
  name: 'demoRecreate',
  initialState,
  reducers: {
    confirmAccess: (state, action) => {
      state.password = action.payload.password;
      state.attempts = action.payload.attempts;
    },
    likeDemoImage: (state, action) => {
      const { sessionId, newReaction } = action.payload;
      state.imagesContent = state.imagesContent.map((image) =>
        image.sessionId === sessionId ? { ...image, reaction: newReaction } : image,
      );
    },
    changeTableSettings: (state, action) => {
      state.imagesTableSettings = { ...state.imagesTableSettings, ...action.payload };
    },
    setAttemptsError: (state, action) => {
      state.attemptsError = action.payload;
    },

    resetDemoRecreateData: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(recreateAdDemo.pending, (state) => {
        state.isGenerating = true;
      })
      .addCase(recreateAdDemo.fulfilled, (state, action) => {
        const { content, sourceImageKey } = action.payload;
        const formattedContent = content.map((item) => ({
          ...item,
          sourceImageKey,
          reaction: '',
          id: item.sessionId,
        }));
        state.isGenerating = false;
        state.imagesContent = [...formattedContent, ...state.imagesContent];
        state.attempts = state.attempts - 1;
      })
      .addCase(recreateAdDemo.rejected, (state) => {
        state.isGenerating = false;
      });
  },
});

export const { resetDemoRecreateData, confirmAccess, likeDemoImage, changeTableSettings, setAttemptsError } =
  demoRecreateSlice.actions;

export default demoRecreateSlice.reducer;
